module.exports = __webpack_public_path__ + "saira-semibold-webfont.90ca920d8c6ea55754bb.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-semibold-webfont.svg
// module id = ../../../../../src/assets/fonts/saira-semibold-webfont.svg
// module chunks = styles